import ProtectedResponsiveImage from './ProtectedResponsiveImage';

export default ProtectedResponsiveImage; 